import React, { Component, Fragment } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../modules/SimpleInput";
import OnSubmissionDetailFilter from "./onSubmissionDetailFilter";
import { tableColumns } from "./config";
import { getValueFromDDL, removeNullFields } from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import Api from "../../../../Services/Api";
import * as R from "ramda";
import { fetchDataAsync } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";

class OnSubmissionDetail extends Component {
  constructor(props) {
    super(props);
    this.initialSearch = {
      nomorMesin: null,
    };
    this.initialFilterData = {
      namaSTNK: null,
      namaPembeli: null,
      nomorRangka: null,
      nomorMesin: null,
    };
    this.state = {
      loading: false,
      filterModalVisible: false,
      search: this.initialSearch,
      filterData: this.initialFilterData,
      tableColumns: [],
      // tableColumns: [
      //     ...tableColumns.thirdPage,
      //     {
      //         name: "checked",
      //         label: "Action",
      //         options: {
      //             customBodyRender: (val, tableMeta) => {
      //                 return (
      //                     <FlexView vAlignContent="center" style={{gap: 10}}>
      //                         <SimpleCheckBox
      //                             id="checkbox_action_on_submission_detail"
      //                             checked={val}
      //                             disabled={this.props.action == "edit" && this.state.processSamsat == "DONE" ? true : false}
      //                             onChange={(e) => this.handleChecked(tableMeta.rowIndex, e)}
      //                         />
      //                     </FlexView>
      //                 );
      //             },
      //             sort: false,
      //         },
      //     },
      // ],
      dataTable: [],
      dataRollBackTable: [],
      pagination: {
          page: 1,
          limit: 5,
          totalData: 0,
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchData();
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        kodeCabang: this.props.selectedCabang,
        nomorPengajuan: this.props.controls.nomorPengajuan?.value,
        bbnId: this.props.controls.bbnId?.value?.value,
      },
      filterData: {
        ...prevState.filterData,
        kodeCabang: this.props.selectedCabang,
        nomorPengajuan: this.props.controls.nomorPengajuan?.value,
        bbnId: this.props.controls.bbnId?.value?.value,
      },
    }));
    this.handleTriggerLoading();
  };

  getTableColumns = () => {
    return [
      ...tableColumns.thirdPage,
      {
        name: "checked",
        label: "Action",
        options: {
          customBodyRender: (val, tableMeta) => {
            const rowIndex = tableMeta.rowIndex;
            const rowData = this.state.dataTable[rowIndex];
            const isDisabled = this.props.action === "edit" && rowData?.processSamsatStatus === "DONE"; 

            return (
              <FlexView vAlignContent="center" style={{ gap: 10 }}>
                <SimpleCheckBox
                  id={`checkbox_action_on_submission_detail_${rowIndex}`}
                  checked={val}
                  disabled={isDisabled}
                  onChange={(e) => this.handleChecked(rowIndex, e)}
                />
              </FlexView>
            );
          },
          sort: false,
        },
      },
    ];
  };

  handleModalFilterVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterModalVisible: !prevState.filterModalVisible,
    }));
  };

  handleValueChangeSearch = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: value,
      },
    }));
  };

  handleClearSearch = () => {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        ...this.initialSearch,
      },
    }));
  };

  handleSubmitSearch = async () => {
    this.handleTriggerLoading();
    let requestBody = {
      ...removeNullFields(this.parseFilterData(this.state.search)),
    };

    await this.fetchData(requestBody);
    this.handleTriggerLoading();
    this.handleClearFilter();
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: {
        ...prevState.filterData,
        ...this.initialFilterData,
      },
    }));
  };

  handleOnSubmitFilter = async () => {
    this.handleTriggerLoading();
    let requestBody = {
      ...removeNullFields(this.parseFilterData(this.state.filterData)),
    };

    await this.fetchData(requestBody);
    this.handleClearSearch();
    this.handleModalFilterVisibility();
    this.handleTriggerLoading();
  };

  handleChecked = (index, e) => {
    const isChecked = e.target.checked;
    this.setState((prevState) => ({
      ...prevState,
      dataTable: prevState.dataTable.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            checked: isChecked,
          };
        } else {
          return item;
        }
      }),
    }));
  };

  handleSubmit = () => {
    this.props.onSubmitDetail(
      this.state.dataTable.filter((data) => data.checked)
    );
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  parseFilterData(data) {
    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
    };
  }

  fetchData = async (body) => {
    const defReqBody = {
      kodeCabang: this.props.selectedCabang?.value,
      bbnId: this.props.controls.bbnId?.value?.value,
      nomorPengajuan: this.props.controls?.nomorPengajuan?.value || null,
    };

    if (this.props.action !== "create") {
      defReqBody.nomorPengajuan = this.props.controls.nomorPengajuan?.value;
    }

    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDraftForSubmission,
      menuName: "Proses Samsat - Belum Pengajuan",
      setError: this.props.setError,
      args: body && Object.keys(body).length > 0 ? body : defReqBody,
    });

    if (
      response.ok &&
      response.data.data !== null &&
      response.data.status === HttpStatus.SUCCESS
    ) {
      const prosesSamsat = response.data.data?.processSamsatStatus;
      this.setState({
        prosesSamsat,
        dataTable: response.data.data.map((item) => {
          const isExist = this.props.dataDetail.some(
            (data) => data.orderH1 === item.orderH1
          );
          return { ...item, checked: isExist };
        }),
        tableColumns: this.getTableColumns(), // ⬅️ Update kolom berdasarkan status
      });
    }
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
        ...prevValue,
        pagination:{
            ...prevValue.pagination,
            page: tableState.page + 1,
        }
    }));
  };

  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const { pagination } = this.state
    return (
      <Fragment>
        <SimpleModal
          title="Detail Data Proses Pengajuan Samsat"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <FlexView
                vAlignContent="center"
                hAlignContent="right"
                style={{ marginBottom: "20px" }}
              >
                <SimpleInput
                  type="text"
                  name="nomorMesin"
                  placeholder="Nomor Mesin"
                  containerclassname="margin-bottom-none"
                  value={this.state.search.nomorMesin}
                  onChange={(e) =>
                    this.handleValueChangeSearch(e.target.name, e.target.value)
                  }
                />
                <SimpleButton
                  text="Cari"
                  onClick={this.handleSubmitSearch}
                  className="margin-top-5px"
                />
                <SimpleButton
                  text="Reset"
                  onClick={this.handleClearSearch}
                  className="margin-top-5px"
                />
                <SimpleButton
                  className={"btn background-red margin-top-5px"}
                  styles={{ width: "unset" }}
                  onClick={this.handleModalFilterVisibility}
                  icon={<i className="fa fa-qrcode"></i>}
                />
              </FlexView>

              <SimpleDataTable
                key={`${this.state.dataTable?.length}-${pagination.page}`}
                columns={this.state.tableColumns}
                data={this.state.dataTable}
                toCount={this.state.dataTable?.length}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
              />

              <FlexView hAlignContent={"right"} style={{ marginTop: "20px" }}>
                <SimpleButton
                  type="button"
                  text="Simpan"
                  onClick={() => this.handleSubmit()}
                />
              </FlexView>
            </ModalContainer>
          }
        />

        {this.state.filterModalVisible && (
          <OnSubmissionDetailFilter
            filterData={this.state.filterData}
            visible={this.state.filterModalVisible}
            onValueChange={this.handleFilterValueChange}
            onSubmit={this.handleOnSubmitFilter}
            onClearForm={this.handleClearFilter}
            onClickClose={this.handleModalFilterVisibility}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </Fragment>
    );
  }
}

export default OnSubmissionDetail;
